import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch} from 'react-redux';
import { onDeleteAccount } from '../../../store/Settings/actions';
import { DeleteAccountModal } from './DeleteAccountModal';

export const DeleteAccount = () => {
    const [openModal, setOpenModal] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onOpenModal = () => {setOpenModal((prev) => !prev)};
    const onCloseModal = () => {setOpenModal((prev) => !prev)};
    const handleConfirmPassword = (e) => {setConfirmPassword(e.target.value)};

    const onDeleteHandle = () => {
        dispatch(onDeleteAccount(confirmPassword));
        onCloseModal();
        setConfirmPassword("")
    };

    return (
        <div className="rounded-lg shadow-md bg-white pt-5 pr-8 pb-4 pl-5 mb-5">
            <p className="font-bold text-base">{t("Delete Account")}</p>

            <p className="col-span-3 sm:col-span-3 py-2.5 text-xs text-gray-600">
                {t(
                    "Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain."
                )}
            </p>

            <div className="mt-8 pr-4 text-right">                        
                <button
                    type="button"
                    onClick={onOpenModal}
                    className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-red-600 hover:bg-gray-700 focus:outline-none"
                >
                    {t("Delete")}
                </button>
            </div>
            <DeleteAccountModal
                visible={openModal}
                onClose={onCloseModal}
                onDelete={onDeleteHandle}
                confirmPassword={confirmPassword}
                handleConfirmPassword={handleConfirmPassword}
            />
        </div>      
    );
}
